<template>
    <span 
        v-b-tooltip.hover.html="{
            title: info,
        }"
        class="text-muted"
    >
        <i class="fas fa-info-circle"></i>
    </span>
</template>

<script>
    export default {
        props: ['info']
    }
</script>

<style>
.tooltip {
    z-index: 100000000 !important; 
}
</style>